import countTo from 'vue-count-to'

export default {
  countTo
}



// WEBPACK FOOTER //
// ./src/app/tenant/dashboard/gadget/resources/components.js